export const debounce = <T extends (...args: any[]) => any>(
  func: T,
  wait: number,
  immediate?: boolean
) => {
  let timeout: ReturnType<typeof setTimeout> | null = null;
  return function (...args: Parameters<T>) {
    const later = () => {
      timeout = null;
      if (!immediate) func.apply(func, args);
    };
    const callNow = immediate && !timeout;
    clearTimeout(timeout as ReturnType<typeof setTimeout>);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(func, args);
  };
};

export const once = function <T extends (...args: any[]) => any>(
  func: T,
  n = 2
) {
  let result: ReturnType<T>;
  if (typeof func !== 'function') {
    throw new TypeError('Expected a function in avatars once');
  }
  return function (this: ThisParameterType<T>, ...args: Parameters<T>) {
    if (--n > 0) {
      result = func.apply(this, args);
    }
    if (n <= 1) {
      func = undefined as any;
    }
    return result;
  };
};
